/* Built In Imports */

/* External Imports */
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';

/* Internal Imports */
/* Components */
import config from '@config';

/* Services */

/**
 * Renders the should Refresh Component
 *
 * @param {string} url - Link
 * @returns {ReactElement} - should Refresh Component
 */

export const getCookie = name => {
  if (typeof window !== 'undefined') {
    // console.log('document-------',name, document.cookie);
    const value = `; ${document.cookie}`;
    const parts = value?.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
  }
};

let domainList = [
    '//prs.innerengineering.com',
    '//prs.isha.in',
    '//sadhana.sadhguru.org',
    'mokshatwo.sushumna.isha.in',
    'goyip.netlify.app',
    'ishangam.isha.in',
    'msrsp.sadhguru.org',
    'ishaoutreach.org',
    'iycblr.sadhguru.org',
    'sp.isha.in',
    'uat-facade-sgexclusive.sadhguru.org/user/createPaymentReferenceNew',
    'sgexclusive.sadhguru.org/user/createPaymentReferenceNew',
    'ishaprs.sushumna.isha.in',
    'online.sadhguru.org',
    'online2.sadhguru.org',
    'registration.innerengineering.com',
    'qa-prs8.innerengineering.com',
    'lingabhairavi.org',
    'beta.lingabhairavi.org',
    'hys.sushumna.isha.in',
    'hys.isha.in',
    'isha.co',
    'poornanga.sushumna.isha.in',
    'poornanga.isha.in',
    'preprod-online.sadhguru.org',
    'uat-arpanam.sadhguru.org',
    'arpanam.sadhguru.org',
    'uat-lbofferings.sadhguru.org',
    'uat-arpanam.sadhguru.org',
    'https://apply.isha.sadhguru.org',
  ];

export const handleUtmParams = (url, extraDomains) => {
  if (extraDomains?.length) {
    domainList = domainList.concat(extraDomains);
  }

  const cookieParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  let newUrl = '';

  const isUrlAvailableForUtmParam = filter(domainList, function (domain) {
    return url.indexOf(domain) > -1;
  });

  if (isUrlAvailableForUtmParam.length) {
    const nUrl = new URL(url);
    const search_params = new URLSearchParams(nUrl.search);
    // let search_params = nUrl.searchParams;

    forEach(cookieParams, function (cookie) {
      const cookieVal = getCookie(cookie);

      if (cookieVal) {
        search_params.set(cookie, cookieVal);
      }
    });
    // change the search property of the main url
    nUrl.search = search_params.toString();

    // the new url string
    newUrl = nUrl.toString();
  } else {
    newUrl = url;
  }
  return newUrl;
};

export const refineUrlDomain = (url, region, lang, extraDomains) => {
  let paramUrl = url;
  if (url?.indexOf('[envurl') > -1) {
    let updatedUrlArr = url.replace('][/envurl]', '')?.replace('[envurl ', '')?.split(' ');
    forEach(updatedUrlArr, function (upUrl) {
      if (config.ENV_NAME === 'production') {
        if (upUrl?.indexOf('prod=') > -1) {
          paramUrl = upUrl.replace("prod='", '').replace("'", '');
        }
      } else {
        if (upUrl?.indexOf('uat=') > -1) {
          paramUrl = upUrl.replace("uat='", '').replace("'", '');
        }
      }
    });
  }

  let finalUrl = '';

  if (!paramUrl) {
    finalUrl = '#!';
  } else if (
    (paramUrl && paramUrl[0] === '#') ||
    paramUrl?.toLowerCase().indexOf('https://') >= 0 ||
    paramUrl?.toLowerCase().indexOf('http://') >= 0 ||
    paramUrl?.toLowerCase().indexOf('mailto:') >= 0 ||
    paramUrl?.toLowerCase().indexOf('()') >= 0
  ) {
    finalUrl = paramUrl;
  } else if (paramUrl?.indexOf('sadhguru-academy/') > -1) {
    finalUrl = paramUrl;
  } else {
    finalUrl = `/sadhguru-academy/${paramUrl[0] === '/' ? '' : '/'}${paramUrl}`;
  }
  if (finalUrl.endsWith('/')) {
    finalUrl = finalUrl.slice(0, -1);
  }
  finalUrl = handleUtmParams(finalUrl, extraDomains);
  return finalUrl;
};

export const getEmbedUrl = url => {
  let retUrl = '';
  if (!url) {
    return retUrl;
  }
  if (url.indexOf('/watch') > -1) {
    retUrl = url.split('=')[1];
  } else if (url.indexOf('/embed/') > -1 || url.indexOf('/youtu.be/') > -1) {
    const splitArr = url.split('/');
    const splittedUrl = splitArr[splitArr.length - 1];
    retUrl =
      splittedUrl.split('?').length > 1
        ? splittedUrl.split('?')[0]
        : splittedUrl;
  } else {
    retUrl = url;
  }
  return retUrl;
};